<template>
    <div class="mb-2">
        <template v-if="map.active && map.local == 'top'">
            <div v-if="company.coordinates && company.coordinates.lat && company.coordinates.lng" class="mb-2">
                <GoogleMap
                    :widthPercent="map.width"
                    :heightPixel="map.height"
                    :lat="company.coordinates.lat"
                    :lng="company.coordinates.lng"
                    :themeDark="map.theme_dark"
                />
            </div>
            <c-span
                v-if="message_company.active"
                :style="`max-width: ${map.width}%`"
                class="msg-company"
            >
                {{ message_company.msg }}
            </c-span>
        </template>
        <form v-if="form_card.active == true" @submit.prevent="submit()" class="row mb-4">
            <div class="col-12 col-lg-8">
                <div class="row">
                    <div class="col-12">
                        <primary-title>Contato</primary-title>
                    </div>
                    <div class="col-12">
                        <page-site
                            v-if="page_body && description.local == 'top'"
                            v-html="page_body"
                            :style="`max-width: ${description.max_width}%`"
                            class="page-contact-desc mb-3"
                        ></page-site>
                    </div>                    
                    <div class="col-12 col-sm-6 mb-1">
                        <input
                            type="hidden"
                            v-model="form.tokenRecaptcha"
                            name="g-recaptcha-response"
                        />
                        <form-group class="form-group required-field">
                            <label for="contact_name">Nome</label>
                            <input
                                type="text"
                                class="form-input form-wide"
                                name="contact_name"
                                id="contact_name"
                                v-model="form.name"
                                placeholder="Nome"
                            />
                            <div
                                v-if="
                                    $v.form.name.$error &&
                                        !$v.form.name.required
                                "
                                class="required"
                            >
                                * Nome obrigatório
                            </div>
                        </form-group>
                    </div>
                    <div class="col-12 col-sm-6 mb-1">
                        <form-group class="form-group required-field">
                            <label for="contact_email">Email</label>
                            <input
                                type="email"
                                class="form-input form-wide"
                                name="contact_email"
                                id="contact_email"
                                v-model="form.email"
                                placeholder="Email"
                            />
                            <div
                                v-if="
                                    $v.form.email.$error &&
                                        !$v.form.email.required
                                "
                                class="required"
                            >
                                * Email obrigatório
                            </div>
                            <div
                                v-else-if="
                                    $v.form.email.$error && !$v.form.email.email
                                "
                                class="required"
                            >
                                * Email inválido
                            </div>
                        </form-group>
                    </div>
                    <div class="col-12 col-sm-6 mb-1">
                        <form-group class="form-group required-field">
                            <label for="contact_phone">Telefone</label>
                            <input
                                type="text"
                                class="form-input form-wide"
                                name="contact_phone"
                                id="contact_phone"
                                v-model="form.phone"
                                v-mask="'(##) #####-####'"
                                placeholder="Telefone"
                            />
                            <div
                                v-if="
                                    $v.form.phone.$error &&
                                        !$v.form.phone.required
                                "
                                class="required"
                            >
                                * Telefone obrigatório
                            </div>
                        </form-group>
                    </div>
                    <div class="col-12 col-sm-6 mb-1">
                        <form-group class="form-group required-field">
                            <label for="contact_topic">Assunto</label>
                            <input
                                type="text"
                                class="form-input form-wide"
                                name="contact_topic"
                                id="contact_topic"
                                v-model="form.topic"
                                placeholder="Assunto"
                            />
                            <div
                                v-if="
                                    $v.form.topic.$error &&
                                        !$v.form.topic.required
                                "
                                class="required"
                            >
                                * Assunto obrigatório
                            </div>
                        </form-group>
                    </div>
                    <div class="col-12 mb-1">
                        <form-group class="form-group">
                            <label for="contact_description">Descrição</label>
                            <textarea
                                class="form-input form-wide"
                                name="contact_description"
                                id="contact_description"
                                v-model="form.description"
                                style="min-height: 150px;"
                            />
                        </form-group>
                    </div>
                    <div class="col-12">
                        <c-button
                            :backgroundColor="
                                $root.$children[0].theme.products.button
                                    .background_color
                            "
                            :backgroundColorHover="
                                $root.$children[0].theme.products.button
                                    .background_color_hover
                            "
                            :color="
                                $root.$children[0].theme.products.button.color
                            "
                            :colorHover="
                                $root.$children[0].theme.products.button
                                    .color_hover
                            "
                            :borderColor="
                                $root.$children[0].theme.products.button
                                    .border_color
                            "
                            :borderColorHover="
                                $root.$children[0].theme.products.button
                                    .border_color_hover
                            "
                            :borderRadius="
                                $root.$children[0].theme.products.button
                                    .border_radius
                            "
                            type="submit"
                            margin="0px 3rem 0px 0px"
                            :textTransform="
                                $root.$children[0].theme.products.button
                                    .text_transform
                            "
                            height="unset"
                            minWidth="124px"
                            padding="1rem 2rem"
                            display="inline-block"
                            textAlign="center"
                            lineHeight="1.5"
                            letterSpacing=".1rem"
                            transition="all .3s"
                        >
                            Enviar
                        </c-button>
                    </div>
                </div>
            </div>
        </form>
        <page-site
            v-if="page_body && description.local == 'bottom'"
            v-html="page_body"
            :style="`max-width: ${description.max_width}%`"
            class="page-contact-desc"
        ></page-site>
        <LoadingApp :isLoading.sync="isLoading" :is_full_page="true" />
        <template v-if="map.active && map.local == 'bottom'">
            <c-span
                v-if="message_company.active"
                :style="`max-width: ${map.width}%`"
                class="msg-company"
            >
                {{ message_company.msg }}
            </c-span>
            <div v-if="company.coordinates && company.coordinates.lat && company.coordinates.lng">
                <GoogleMap
                    :widthPercent="map.width"
                    :heightPixel="map.height"
                    :lat="company.coordinates.lat"
                    :lng="company.coordinates.lng"
                    :themeDark="map.theme_dark"
                />
            </div>
        </template>
    </div>
</template>

<script>
import { CButton } from "../../components/Styles/Button/styled";
import {
    CFormGroup,
    CPrimaryTitle,
    CSpan
} from "../../components/Styles/Components/styled";
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import LoadingApp from "../../components/LoadingApp.vue";
import GoogleMap from "../../components/maps/GoogleMap.vue";
import { CPageSite } from '../../components/Styles/Template/styled';
export default {
    name: "ContactPage",
    components: {
        "form-group": CFormGroup,
        "c-button": CButton,
        'c-span': CSpan,
        'page-site': CPageSite,
        'primary-title': CPrimaryTitle,
        LoadingApp,
        GoogleMap
    },
    props: {
        colors_page: {
            default:'',
            type:String
        },
        page: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            form: {
                name: null,
                email: null,
                phone: null,
                topic: null,
                description: null,
                tokenRecaptcha: null
            },
            isLoading: false,
            company: this.$root.$children[0].$attrs.company,
            message_company: {
                active: JSON.parse(this.colors_page)?.contact_page?.message_company?.active ?? true,
                msg: this.$root.$children[0].$attrs.company?.settings?.message ?? '' 
            },
            map: {
                active: JSON.parse(this.colors_page)?.contact_page?.map?.active ?? true,
                local: JSON.parse(this.colors_page)?.contact_page?.map?.local ?? 'bottom',
                width: JSON.parse(this.colors_page)?.contact_page?.map?.width ?? 66,
                height: JSON.parse(this.colors_page)?.contact_page?.map?.height ?? 300,
                theme_dark: JSON.parse(this.colors_page)?.contact_page?.map?.theme_dark ?? false
            },
            form_card: {
                active: JSON.parse(this.colors_page)?.contact_page?.form?.active ?? true
            },
            page_body: JSON.parse(this.page).body,
            description: {
                local: JSON.parse(this.colors_page)?.contact_page?.desc?.local ?? 'top',
                max_width: JSON.parse(this.colors_page)?.contact_page?.desc?.width ?? 100//66
            }
        };
    },
    validations: {
        form: {
            name: {
                required
            },
            email: {
                required,
                email
            },
            phone: {
                required
            },
            topic: {
                required
            }
        }
    },
    methods: {
        ...mapActions("contact", ["ActionCreate"]),
        ...mapActions("recaptcha", ["actionGetTokenRecaptcha"]),
        async submit() {
            let tokenRecaptcha =
                this.company?.analytics_settings?.recaptcha?.chave_site ?? null;
            this.isLoading = true;
            if (this.$v.$invalid) {
                this.$v.form.$touch();
                this.isLoading = false;
                return;
            }
            if (!tokenRecaptcha) {
                return this.send();
            }
            this.actionGetTokenRecaptcha({
                token: tokenRecaptcha,
                action: "create_contact"
            });
        },
        async send() {
            try {
                let data = { ...this.form };
                await this.ActionCreate(data);
                if(this.facebookPixel?.settings?.Contact == true) {
                    fbq('track', 'Contact')
                }
                this.$v.$reset();
                this.resetForm();
                alert("Contato enviado!");
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                alert(error.msg);
                console.log(error.validator);
            }
        },
        resetForm() {
            this.form.name = null;
            this.form.email = null;
            this.form.phone = null;
            this.form.topic = null;
            this.form.description = null;
            this.form.tokenRecaptcha = null;
        }
    },
    computed: {
        ...mapState("recaptcha", ["token"]),
        ...mapState('company', [
            'facebookPixel'
        ])
    },
    watch: {
        async token(val) {
            if (!val) return;
            this.form.tokenRecaptcha = val;
            await this.send();
        }
    }
};
</script>

<style scoped>
label {
    margin-bottom: 0.3rem;
}
.msg-company {
    font-size: 1.5rem;
    display: inline-flex;
    margin-bottom: 15px;
}
@media (max-width: 991px) {
    .msg-company {
        max-width: 100% !important;
    }
    .page-contact-desc {
        max-width: 100% !important;
    }
}
</style>
